import api from "@helpers/api";

import { URLS } from "@constants/urls";

import { AttachedFilesType } from "@type/HRM/attached-files";
import { UploadFileType } from "@type/HRM/upload-file";

const apiEndPoint = `${process.env.REACT_APP_EMPLOYEE_SERVICE_URL}${process.env.REACT_APP_EMPLOYEE_SERVICE_PORT}/${process.env.REACT_APP_EMPLOYEE_SERVICE}/api/${process.env.REACT_APP_API_VERSION}/${process.env.REACT_APP_API_PRIVATE}/${URLS.EMPLOYEES}`;

export const getAttachedFiles = (() => {
  return async (data: {
    data: string;
  }): Promise<{ data: AttachedFilesType }> => {
    const id = data.data;
    return api.get(`${apiEndPoint}/${id}/attached-files`).then((response) => {
      return { data: response.data.documents };
    });
  };
})();

export const createAttachedFile = (() => {
  return async (data: { data: UploadFileType }) => {
    const { employeeID, ...rest } = data.data;
    const { id } = rest;
    const action = id ? "put" : "post";

    const putUrl = `${apiEndPoint}/${employeeID}/attached-files/${id}`;
    const postUrl = `${apiEndPoint}/${employeeID}/attached-files`;
    const url = id ? putUrl : postUrl;

    return (
      api[action](url, { ...rest })
        // .post(`${apiEndPoint}/${employeeID}/attached-files`, { ...rest })
        .then((response) => {
          return {
            data: response.data,
          };
        })
    );
  };
})();

export const deleteAttachedFile = (() => {
  return async (data: { data: UploadFileType }) => {
    const { employeeID, fileData } = data.data;

    return api
      .delete(`${apiEndPoint}/${employeeID}/attached-files/${fileData.id}`)
      .then(() => {
        return { data: fileData };
      });
  };
})();
